var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "riRightNavContainer" }, [
    _vm.isMobile
      ? _c("div", { ref: "mobileNav", staticClass: "riRightMobileNav" }, [
          _c(
            "a",
            {
              staticClass: "riRightMobileNavIcon",
              attrs: { href: _vm.rootUrl }
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                _c("path", {
                  attrs: {
                    fill: "#17365c",
                    d: "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "riRightNavMobileLabel" }, [
                _vm._v("Start")
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "riRightMobileNavIcon",
            domProps: {
              innerHTML: _vm._s(_vm.getBottomBarItemHtmlViaPosition(1))
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "riRightMobileNavIcon",
            domProps: {
              innerHTML: _vm._s(_vm.getBottomBarItemHtmlViaPosition(2))
            }
          }),
          _vm._v(" "),
          _vm.navItems.length
            ? _c(
                "div",
                {
                  staticClass: "riRightMobileNavIcon",
                  on: {
                    click: function($event) {
                      _vm.toggleNaviMobile()
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      ref: "mobileToggleButtonIcon",
                      attrs: { viewBox: "0 0 24 24" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "#17365c",
                          d:
                            "M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      ref: "mobileToggleButtonLabel",
                      staticClass: "riRightNavMobileLabel"
                    },
                    [_vm._v("Mehr")]
                  )
                ]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "outer",
        staticClass: "riRightNavi",
        class: { hidden: _vm.isMobile }
      },
      [
        _vm.isMobile
          ? _c("div", { staticClass: "riRightNavClose" }, [
              _c("span"),
              _vm._v(" "),
              _c("div", { staticClass: "riRightNavCloseContainer" }, [
                _c(
                  "span",
                  {
                    staticClass: "riRightNavCloseLabel",
                    on: {
                      click: function($event) {
                        _vm.toggleNaviMobile()
                      }
                    }
                  },
                  [_vm._v(" Schließen ")]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { ref: "inner", class: { riRightNaviInner: true } },
          [
            _vm._l(_vm.navEmptyItemsNarrow, function(e, i) {
              return _c("div", {
                key: "en" + i,
                staticClass: "riItem riEmptyNarrow"
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.navEmptyItemsWide, function(e, i) {
              return _c("div", {
                key: "ew" + i,
                staticClass: "riItem riEmptyWide"
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.navItems, function(item, idx) {
              return _c(
                "a",
                {
                  key: idx,
                  class: {
                    riItem: true,
                    hover: _vm.hoveredLink === item,
                    riMobileOnly: item.mobileOnly
                  },
                  style: _vm.getStyle(item),
                  attrs: {
                    "data-bottom-bar-position": item.bottomBarPosition,
                    href: item.url
                  },
                  on: {
                    mouseover: function($event) {
                      _vm.hoveredLink = item
                    },
                    mouseleave: function($event) {
                      _vm.hoveredLink = null
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "riIcon",
                    domProps: { innerHTML: _vm._s(item.svg) }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "riLabel" }, [
                    _vm._v(_vm._s(item.label))
                  ])
                ]
              )
            })
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _vm.isMobile
      ? _c("div", {
          ref: "mobileBackground",
          staticClass: "mobileBackground hidden"
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }